import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

const defaultText = {
  fontFamily: "Manrope",
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: 0.25,
  color: colors.gray600,
  "@media screen and (max-width: 1024px)": {
    fontSize: 12,
  },
};

interface TextProps {
  hasErrors?: boolean;
}
export const Text = styled("span")(({ hasErrors }: TextProps) => ({
  ...defaultText,
  lineHeight: "12px",
  color: hasErrors ? colors.error600 : defaultText.color,
}));
